module.exports = __webpack_public_path__ + "img/background061.472703e3.jpg";